export const ERROR_PATH = '/error';
export const NOT_AUTHORIZED_PATH = '/not-authorized';
export const PARTNER_PATH = '/partner';
export const PRICING_PATH = '/pricing';
export const RECOMMENDATION_PATH = '/recommendation';
export const RESULTS_PATH = '/results';
export const CONCIERGE_PATH = '/concierge';
